import React, {useCallback, useEffect, useState} from "react";

import Checkbox from "../CheckboxNew/Checkbox";

import {fetchData} from "../Service/graphQlService";

import {GET_RECORD_GROUPS} from "../Graphql/Queries/recordGroupsQuery";

import {

  CREATE_RECORD_GROUP,

  DELETE_RECORD_GROUP,

  SET_RECORD_GROUP_MEMBERSHIP,

} from "../Graphql/Mutations/recordGroupsMutation";

import {parseGroupMemberCount} from "../RecordGroups/recordGroupsService";

import "./RecordGroupsPanel.scss";

// Group deletion is restricted to these users (case-insensitive email match), mirroring the
// server-side GROUP_DELETE_AUTHORIZED_EMAILS authorization. People/Property groups are
// otherwise public to all users.
var GROUP_DELETE_AUTHORIZED_EMAILS = ["jpierson@strivere.com", "jbavanam@strivere.com", "jbavanam@sageitinc.com"];

export default function RecordGroupsPanel(props) {

  var groupType = props.groupType;

  var memberId = props.memberId ? Number(props.memberId) : null;

  var ownerAgentId = props.ownerAgentId ? Number(props.ownerAgentId) : null;

  var viewMode = props.viewMode;

  var title = props.title || "Groups";

  var currentUserEmail = "";
  try {
    var storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
    currentUserEmail = (storedUserData.email || "").trim().toLowerCase();
  } catch (e) {
    currentUserEmail = "";
  }
  var canDelete = GROUP_DELETE_AUTHORIZED_EMAILS.indexOf(currentUserEmail) !== -1;



  var groupsState = useState([]);

  var groups = groupsState[0];

  var setGroups = groupsState[1];



  var newGroupNameState = useState("");

  var newGroupName = newGroupNameState[0];

  var setNewGroupName = newGroupNameState[1];



  var isBusyState = useState(false);

  var isBusy = isBusyState[0];

  var setIsBusy = isBusyState[1];



  var errorState = useState(null);

  var error = errorState[0];

  var setError = errorState[1];



  var loadGroups = useCallback(function() {

    if (!ownerAgentId) return;

    setIsBusy(true);

    setError(null);

    fetchData(GET_RECORD_GROUPS, {

      group_type: groupType,

      owner_agent_id: ownerAgentId,

      member_id: memberId || null,

    }).then(function(res) {

      var payload = res && res.data && res.data.getRecordGroups;

      if (!payload || !payload.success) {

        setError((payload && payload.error) || "Failed to load groups.");

        setGroups([]);

      } else {

        setGroups(payload.data || []);

      }

      setIsBusy(false);

    }).catch(function(e) {

      setError((e && e.message) || "Failed to load groups.");

      setGroups([]);

      setIsBusy(false);

    });

  }, [groupType, ownerAgentId, memberId]);



  useEffect(function() {

    loadGroups();

  }, [loadGroups]);



  var onCreateGroup = useCallback(function(event) {

    if (event && event.preventDefault) event.preventDefault();

    if (viewMode || !ownerAgentId || !newGroupName.trim()) return;

    setIsBusy(true);

    setError(null);

    fetchData(CREATE_RECORD_GROUP, {

      group_type: groupType,

      owner_agent_id: ownerAgentId,

      group_name: newGroupName.trim(),

    }).then(function(res) {

      var payload = res && res.data && res.data.createRecordGroup;

      if (!payload || !payload.success) {

        setError((payload && payload.error) || "Failed to create group.");

        setIsBusy(false);

        return;

      }

      setNewGroupName("");

      loadGroups();

    }).catch(function(e) {

      setError((e && e.message) || "Failed to create group.");

      setIsBusy(false);

    });

  }, [groupType, ownerAgentId, newGroupName, viewMode, loadGroups]);



  var onDeleteGroup = useCallback(function(groupId) {

    if (viewMode || !ownerAgentId || !canDelete) return;

    if (!window.confirm("Delete this group?")) return;

    setIsBusy(true);

    setError(null);

    fetchData(DELETE_RECORD_GROUP, {

      group_type: groupType,

      owner_agent_id: ownerAgentId,

      group_id: Number(groupId),

    }).then(function(res) {

      var payload = res && res.data && res.data.deleteRecordGroup;

      if (!payload || !payload.success) {

        setError((payload && payload.error) || "Failed to delete group.");

        setIsBusy(false);

        return;

      }

      loadGroups();

    }).catch(function(e) {

      setError((e && e.message) || "Failed to delete group.");

      setIsBusy(false);

    });

  }, [groupType, ownerAgentId, viewMode, loadGroups]);



  var onToggleMembership = useCallback(function(group) {

    if (viewMode || !ownerAgentId || !memberId || !group) return;

    var nextMember = !group.is_member;

    setIsBusy(true);

    setError(null);

    fetchData(SET_RECORD_GROUP_MEMBERSHIP, {

      group_type: groupType,

      owner_agent_id: ownerAgentId,

      group_id: Number(group.group_id),

      member_id: memberId,

      is_member: nextMember,

    }).then(function(res) {

      var payload = res && res.data && res.data.setRecordGroupMembership;

      if (!payload || !payload.success) {

        setError((payload && payload.error) || "Failed to update group membership.");

        setIsBusy(false);

        return;

      }

      setGroups(function(prev) {

        return (prev || []).map(function(item) {

          if (Number(item.group_id) !== Number(group.group_id)) return item;

          return Object.assign({}, item, {is_member: nextMember});

        });

      });

      setIsBusy(false);

    }).catch(function(e) {

      setError((e && e.message) || "Failed to update group membership.");

      setIsBusy(false);

    });

  }, [groupType, ownerAgentId, memberId, viewMode]);



  return (

    <div className="RecordGroupsPanel" data-is-busy={isBusy ? true : null}>

      <div className="RecordGroupsPanel_header">{title}</div>

      {ownerAgentId && !viewMode ? (

        <form className="RecordGroupsPanel_create" onSubmit={onCreateGroup}>

          <input

            type="text"

            className="RecordGroupsPanel_create-input"

            placeholder="New group name"

            value={newGroupName}

            onChange={function(e) { setNewGroupName(e.target.value); }}

            disabled={isBusy || !ownerAgentId}

          />

          <button

            type="submit"

            className="button-new positive RecordGroupsPanel_create-btn"

            disabled={isBusy || !ownerAgentId || !newGroupName.trim()}

          >

            Add

          </button>

        </form>

      ) : null}

      {!memberId ? (

        <div className="RecordGroupsPanel_hint">Save this record before assigning groups.</div>

      ) : null}

      <div className="RecordGroupsPanel_list">

        {(groups || []).map(function(group) {

          var memberCount = parseGroupMemberCount(group.group_members);
          var countLabel = groupType === "property"
            ? (memberCount === 1 ? "Property" : "Properties")
            : (memberCount === 1 ? "member" : "members");

          return (

            <div key={group.group_id} className="RecordGroupsPanel_row">

              <Checkbox

                text={group.group_name}

                type={(!memberId || viewMode) ? "uncheckable" : "checkable"}

                isSelected={!!group.is_member}

                handleClick={function() { onToggleMembership(group); }}

                name={"group-" + group.group_id}

                viewMode={!memberId || viewMode}

              />

              <span className="RecordGroupsPanel_count">{memberCount} {countLabel}</span>

              {canDelete && !viewMode ? (

                <button

                  type="button"

                  className="RecordGroupsPanel_delete"

                  title="Delete group"

                  onClick={function() { onDeleteGroup(group.group_id); }}

                  disabled={isBusy}

                >

                  ×

                </button>

              ) : null}

            </div>

          );

        })}

        {!isBusy && (!groups || !groups.length) ? (

          <div className="RecordGroupsPanel_empty">No groups yet.</div>

        ) : null}

      </div>

      {error ? <div className="RecordGroupsPanel_error">{error}</div> : null}

    </div>

  );

}


